import { PharmacySegment } from '../../../../../pages/admin-dashboard/pharmacy-segment/pharmacy-segment.model';
import { PharmacySegmentRow, SegmentHeaderItem } from './pharmacy-segment-table.module';

export function buildSegmentHeaderItems(isArabic: boolean): SegmentHeaderItem[] {
  return [
    { key: 'index', label: '#' },
    { key: 'titleDisplay', label: isArabic ? 'اسم الشريحة' : 'Segment Title' },
    { key: 'paymentTermDisplay', label: isArabic ? 'مدة السداد' : 'Payment Term' },
    { key: 'extraDiscountDisplay', label: isArabic ? 'نسبة الخصم الإضافي' : 'Extra Discount Percentage' },
    { key: 'createdOnBy', label: isArabic ? 'تاريخ الإنشاء / بواسطة' : 'Creation Date / By' },
    { key: 'lastModifiedOnBy', label: isArabic ? 'آخر تعديل في / بواسطة' : 'Last Modified On / By' },
    { key: 'actions', type: 'actions', label: '' },
  ];
}

export function mapSegmentsToRows(
  segments: PharmacySegment[],
  page: number,
  perPage: number,
  isArabic: boolean
): PharmacySegmentRow[] {
  return segments.map((item, i) => ({
    ...item,
    index: i + 1 + (page - 1) * perPage,
    titleDisplay: isArabic && item.titleAr ? item.titleAr : item.titleEn,
    paymentTermDisplay: isArabic
      ? `${item.paymentTermDays} ${item.paymentTermDays === 1 ? 'يوم' : 'ايام'}`
      : `${item.paymentTermDays} ${item.paymentTermDays === 1 ? 'day' : 'days'}`,
    extraDiscountDisplay: `${item.additionalDiscount}%`,
    createdOn: item.createdOn,
    createdBy: item.createdBy?.fullName ?? '',
    lastModifiedOn: item.lastModifiedOn || null,
    lastModifiedBy: item.lastModifiedBy?.fullName ?? '',
  }));
}